import { useTranslation } from 'react-i18next';

import { notificationsService } from 'src/services/notifications.service';

export const useAssignmentNotifications = () => {
  const { t } = useTranslation();
  const showNewAssignmentsNotification = (count: number) =>
    notificationsService.showNotification(
      t('newAssignmentsMessage', { count }),
    );

  return { showNewAssignmentsNotification };
};
